import React from 'react'
import './Answer.css'

function Answer (props) {
    return (
        <div className={'Answer-block' + (props.chosen ? ' chosen' : '')} onClick={props.onClick}>
            <a>
                {props.text}
            </a>
        </div>
    )
}

export default Answer
